import { useEffect, useState } from 'react';

import { getSelectedConsolidations } from '../api/getSelectedConsolidations';
import { addOrUpdateFormField } from '../store/applicationform';
import { SelectedConsolidations } from '../types/ConsolidationTypes';
import { useAppDispatch, useAppSelector } from './hooks';
import useArnFromPath from './useArnFromPath';
import useSettings from './useSettings';
/**
 * Runs the service for get selected consolidations
 * @returns an object with the selected consolidations
 */

const useGetSelectedConsolidations = () => {
    const { authenticationData } = useAppSelector((state) => state.authentication);
    const { apiKey, proxyBaseUrl } = useSettings();
    const applicationReferenceNumber = useArnFromPath();
    const [selectedConsolidations, setSelectedConsolidations] = useState<SelectedConsolidations>();
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (!applicationReferenceNumber) {
            return;
        }
        getSelectedConsolidations(proxyBaseUrl, apiKey, applicationReferenceNumber, authenticationData)
            .then((consolidations) => {
                setSelectedConsolidations(consolidations);
                consolidations.consolidations.forEach((consolidation) => {
                    if (consolidation.accountNumber) {
                        dispatch(
                            addOrUpdateFormField({
                                fieldName: `consolidation_${consolidation.internalId};accountNumber`,
                                value: consolidation.accountNumber,
                            }),
                        );
                    }
                    if (consolidation.kidNumber) {
                        dispatch(
                            addOrUpdateFormField({
                                fieldName: `consolidation_${consolidation.internalId};kidNumber`,
                                value: consolidation.kidNumber,
                            }),
                        );
                    }
                });
            })
            .catch(() => {
                'error';
            });
    }, [applicationReferenceNumber]);

    return { selectedConsolidations };
};
export default useGetSelectedConsolidations;
